import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-media-icon',
  templateUrl: './files-media.component.html'
})
export class FilesMediaComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
